/**
* 请求明细 明细数据
*/
<template>
    <div class="dataDetail">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>请求明细</el-breadcrumb-item>
            <el-breadcrumb-item>明细数据</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="应用">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.app_name"
                    :fetch-suggestions="paramValueSearch1" @select="handleSelect($event,1)"  @change="handleChange1" placeholder="应用">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="渠道">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.channel_name"
                    :fetch-suggestions="paramValueSearch2" @select="handleSelect($event,2)"  @change="handleChange2" placeholder="渠道">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="点击开始日期">
                <el-date-picker size="small" v-model="formInline.click_begindate" value-format="yyyy-MM-dd" type="date"
                    placeholder="输入点击开始日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="点击截至日期">
                <el-date-picker size="small" v-model="formInline.click_enddate" value-format="yyyy-MM-dd" type="date"
                    placeholder="输入点击截至日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="激活开始日期">
                <el-date-picker size="small" v-model="formInline.activate_begindate" value-format="yyyy-MM-dd" type="date"
                    placeholder="输入激活开始日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="激活截至日期">
                <el-date-picker size="small" v-model="formInline.activate_enddate" value-format="yyyy-MM-dd" type="date"
                    placeholder="输入激活截至日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="回调开始日期">
                <el-date-picker size="small" v-model="formInline.callback_begindate" value-format="yyyy-MM-dd" type="date"
                    placeholder="输入回调开始日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="回调截至日期">
                <el-date-picker size="small" v-model="formInline.callback_enddate" value-format="yyyy-MM-dd" type="date"
                    placeholder="输入回调截至日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="投放明细ID">
                <el-input size="small" v-model="formInline.puton_id" placeholder="投放明细ID"></el-input>
            </el-form-item>
            <el-form-item label="关键词">
                <el-input size="small" v-model="formInline.keyword" placeholder="关键词"></el-input>
            </el-form-item>
            <el-form-item label="IDFA">
                <el-input size="small" v-model="formInline.idfa" placeholder="IDFA"></el-input>
            </el-form-item>
            <el-form-item label="回调状态">
                <el-select size="small" v-model="formInline.callback_status" placeholder="请选择" class="userRole">
                    <el-option label="全部" :value="-1"></el-option>
                    <el-option label="渠道激活" :value="0"></el-option>
                    <el-option label="应用回调" :value="1"></el-option>
                  </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search" v-auth="'appinfo.list'">搜索
                </el-button>
                <el-button size="small" type="default" icon="el-icon-refresh" @click="reset">重置</el-button>
                <el-button size="small" type="default" icon="el-icon-download" @click="chooseExport">导出</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <div class="el-table-con">
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                element-loading-text="拼命加载中" style="width: 100%;" @sort-change="sortChange">
                <el-table-column align="center" type="selection" width="60">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="click_request_id" label="点击ID" width="100">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="puton_id" label="投放ID" width="100">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_id" label="应用ID" width="100">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_name" label="应用名称" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_id" label="渠道ID" width="100">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_name" label="渠道名称" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="idfa" label="IDFA" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="click_ip" label="点击ip" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="activate_ip" label="激活ip" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="keyword" label="关键词" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="devicemodel" label="设备型号" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="systemversion" label="系统版本" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="callback_status" label="回调状态" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="click_time" label="点击时间" width="160">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="activate_time" label="激活时间" width="160">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="callback_time" label="回调时间" width="160">
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>

<script>
    let change = [];
    import {
        detailrequestList,
        appList,
        channelList
    } from '../../api/basisMG'
    import Pagination from '../../components/Pagination'
    export default {
        inject: ['reload'],
        data() {
            return {
                loading: false, //是显示加载
                formInline: {
                    pageindex: 1,
                    pagesize: 20,
                    app_id: '',
                    app_name: '',
                    channel_id: '',
                    channel_name: '',
                    click_begindate: '',
                    click_enddate: '',
                    activate_begindate: '',
                    activate_enddate: '',
                    callback_begindate: '',
                    callback_enddate: '',
                    puton_id: '',
                    keyword: '',
                    idfa: '',
                    callback_status: -1,
                    orderby: ''
                },
                listData: [], //应用数据
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 20,
                    total: 10
                },
                appList:[],
                channelList:[],
                salesmanlist: [], //营销人员列表
                channelerlist:[],
                operationsmanlist: [], //运营人员列表
                time:''
            }
        },
        // 注册组件
        components: {
            Pagination
        },
        /**
         * 数据发生改变
         */

        watch: {},

        /**
         * 创建完毕
         */

        created() { },
        mounted() {
            /*this.getTime();
            if (!this.formInline.click_begindate) {
                this.formInline.click_begindate = this.time;
            }
            var formInline = localStorage.getItem('dataDetail')
            if (formInline) {
                this.formInline = JSON.parse(formInline)
            }
            this.getdata(this.formInline)*/
            this.reset();
            this.getappList();
            this.getchannelList();
            
        },
        /**
         * 里面的方法只有被调用才会执行
         */

        methods: {
            // 获取列表
            getdata(parameter) {
                var that = this;
                that.loading = true;
                detailrequestList(parameter)
                    .then(res => {
                        that.loading = false
                        if (res.statusCode == 200) {
                            that.listData = res.data.datas
                            // 分页赋值
                            that.pageparm.currentPage = res.data.pageindex
                            that.pageparm.pageSize = res.data.pagesize
                            that.pageparm.total = res.data.rowscount
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取应用列表
            getappList() {
                var that = this;
                var data = { 'pagesize': '0' }
                appList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            res.data.datas.forEach(item => {
                                that.appList.push({
                                    value: item.app_name,
                                    id: item.app_id
                                })
                            });
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取渠道列表
            getchannelList() {
                var that = this;
                var data = { 'pagesize': '0' }
                channelList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            res.data.datas.forEach(item => {
                                that.channelList.push({
                                    value: item.channel_name,
                                    id: item.channel_id
                                })
                            });
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.pageindex = parm.currentPage
                this.formInline.pagesize = parm.pageSize
                localStorage.setItem('dataDetail', JSON.stringify(this.formInline))
                this.getdata(this.formInline)
            },
            // 排序
            sortChange(column, prop, order) {
                var order = '';
                if (column.order == 'ascending') {
                    order = 'asc'
                } else if (column.order == 'descending') {
                    order = 'desc'
                }
                if (order) {
                    this.formInline.orderby = column.prop + ' ' + order
                    this.search();
                }
            },
            // 搜索事件
            search() {
                this.formInline.pageindex = 1;
                localStorage.setItem('dataDetail', JSON.stringify(this.formInline))
                this.getdata(this.formInline)
            },
            // 重置
            reset() {
                this.formInline = {
                    pageindex: 1,
                    pagesize: 20,
                    app_id: '',
                    app_name: '',
                    channel_id: '',
                    channel_name: '',
                    click_begindate: '',
                    click_enddate: '',
                    activate_begindate: '',
                    activate_enddate: '',
                    callback_begindate: '',
                    callback_enddate: '',
                    puton_id: '',
                    keyword: '',
                    idfa: '',
                    callback_status: '',
                    orderby:''
                }
                this.getTime();
                this.formInline.click_begindate = this.time;
                // 重置清掉本地搜索缓存
                localStorage.removeItem('dataDetail')
                this.getdata(this.formInline)
            },
            // 自定义输入下拉框
            paramValueSearch1(queryString, cb) {
                var appList = this.appList;
                var results = queryString ? appList.filter(this.createFilter(queryString)) : appList;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            paramValueSearch2(queryString, cb) {
                var channelList = this.channelList;
                var results = queryString ? channelList.filter(this.createFilter(queryString)) : channelList;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return restaurant.value.toUpperCase().match(queryString.toUpperCase()) //模糊查询
                    // return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0); // 精准查询
                };
            },
            handleSelect(item,index){
                if(index == 1){
                    this.formInline.app_id = item.id;
                    this.formInline.app_name = item.value;
                }else if(index == 2){
                    this.formInline.channel_id = item.id;
                    this.formInline.channel_name = item.value;
                }
            },
            handleChange1(val){
                if(val == ''){
                    this.formInline.app_id = '';
                    this.formInline.app_name = '';
                    localStorage.setItem('dataDetail', JSON.stringify(this.formInline))
                }
            },
            handleChange2(val){
                if(val == ''){
                    this.formInline.channel_id = '';
                    this.formInline.channel_name = '';
                    localStorage.setItem('dataDetail', JSON.stringify(this.formInline))
                }
            },
            // 导出
            chooseExport(){
                var formInline = this.formInline
                formInline.pagesize = '0';
                var data='';
                for (const key in formInline) {
                    if(formInline[key]){
                        data+=key+'='+formInline[key]+'&'
                    }
                }
                data=data.slice(0,data.length-1)

                let consturl="https://api.aso.gzjiuyi.net/detailrequest/export?" + data   //下载地址url
                var xhr = new XMLHttpRequest();
                xhr.open("get", consturl, true); // get、post都可
                xhr.responseType = "blob";  
                xhr.setRequestHeader("token",localStorage.getItem('logintoken')); //加请求头
                xhr.onload = function() {
                    if(xhr.status==200){
                        var blob = this.response;
                        var a = document.createElement("a")
                        var url = window.URL.createObjectURL(blob)
                        a.href = url
                        var farmname=consturl.substring(consturl.length-21)
                        a.download = "明细数据.xls"  // 文件名
                    }
                    a.click()
                    window.URL.revokeObjectURL(url)
                } 
                xhr.send();
            },
            // 获取当前日期
            getTime() {
                const date = new Date();
                const Y = date.getFullYear();
                const M = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
                const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                this.time = Y + '-' + M + '-' + D;
            },
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .userRole {
        width: 100%;
    }
</style>
<style>
    .dataDetail .el-table-con {
        height: calc(100vh - 380px) !important;
    }

    .dataDetail .page-box {
        text-align: right !important;
    }

    .dataDetail .el-table__body-wrapper {
        overflow-y: auto !important;
        max-height: calc(100vh - 460px) !important;
    }

    .dataDetail .el-dialog__body {
        max-height: 55vh;
        overflow-y: scroll;
    }

    .dataDetail .el-dialog__body::-webkit-scrollbar {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/views/detailed/dataDetail.vue